/**
 * Config constants
 */

export const apiUrl = "http://localhost:8080";
